import e from "react";
import t from "styled-components";
import n from "prop-types";
import o from "webfontloader";

function r() {
  return (r = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];

      for (var o in n) {
        Object.prototype.hasOwnProperty.call(n, o) && (e[o] = n[o]);
      }
    }

    return e;
  }).apply(this, arguments);
}

function i(e, t) {
  if (null == e) return {};

  var n,
      o,
      r = function (e, t) {
    if (null == e) return {};
    var n,
        o,
        r = {},
        i = Object.keys(e);

    for (o = 0; o < i.length; o++) {
      n = i[o], t.indexOf(n) >= 0 || (r[n] = e[n]);
    }

    return r;
  }(e, t);

  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);

    for (o = 0; o < i.length; o++) {
      n = i[o], t.indexOf(n) >= 0 || Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
    }
  }

  return r;
}

var a = 16,
    l = function l(e) {
  return {
    number: parseFloat(e),
    units: String(e).replace(/^[\d.-]+/, "")
  };
},
    c = function c() {
  for (var e = "", t = 0; t < arguments.length; ++t) {
    var n = t < 0 || arguments.length <= t ? void 0 : arguments[t];
    "" !== e && (e += " ");
    var o = l(n);
    "rem" !== o.units ? e += o.number / a : e += o.number, 0 != o.number && (e += "rem");
  }

  return e;
};

function d(e, t, n) {
  return t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}

function f(e, t) {
  var n = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    t && (o = o.filter(function (t) {
      return Object.getOwnPropertyDescriptor(e, t).enumerable;
    })), n.push.apply(n, o);
  }

  return n;
}

function s(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = null != arguments[t] ? arguments[t] : {};
    t % 2 ? f(n, !0).forEach(function (t) {
      d(e, t, n[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : f(n).forEach(function (t) {
      Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
    });
  }

  return e;
}

var u = function u(e) {
  return {
    number: parseFloat(e),
    units: String(e).replace(/^[\d.-]+/, "")
  };
},
    h = function h() {
  for (var e = "", t = 0; t < arguments.length; ++t) {
    var n = t < 0 || arguments.length <= t ? void 0 : arguments[t];
    "" !== e && (e += " ");
    var o = u(n);
    "rem" !== o.units ? e += o.number / 16 : e += o.number, 0 != o.number && (e += "rem");
  }

  return e;
},
    m = {
  black: "#000000",
  white: "#ffffff",
  red: "#d52b1e",
  charcoal: "#454545",
  green: "#00ac3e",
  blue: "#0088ce",
  yellow: "#ffbc3d",
  orange: "#ed7000",
  coolGray1: "#f6f6f6",
  coolGray3: "#d8dada",
  coolGray6: "#747676",
  coolGray10: "#333333",
  grayLight: "#d8dada"
},
    b = s({}, m, {}, {
  textColor: m.charcoal,
  textColorSuccess: m.white,
  textColorInfo: m.white,
  textColorWarning: m.charcoal,
  textColorError: m.white
}),
    p = {
  fontFamily: '"BrandFont-Text", Helvetica, Arial, sans-serif',
  monospace: '"SFMono-Regular", "RobotoMono-Regular", monospace',
  sans: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"',
  serif: "serif",
  iconFontUrl: "https://respframework.verizon.com/fonts/verizon-icons/fonts.css",
  iconFont: "verizon-icons"
},
    y = {
  light: 300,
  normal: 400,
  medium: 500,
  bold: 700
},
    g = s({}, p, {}, {
  fontColor: b.black,
  fontColorAlt: b.white,
  fontSize: h(16)
}, {
  fontWeights: y,
  fontHeader: p.fontFamily,
  fontBody: p.sans,
  fontWeight: y
}),
    v = s({
  name: "Verizon Theme"
}, b, {}, g, {}, {
  primary: b.black,
  secondary: b.white,
  accent: b.red,
  background: b.white,
  backgroundColorDisabled: b.coolGray3,
  success: b.green,
  info: b.blue,
  warning: b.yellow,
  error: b.orange,
  disabled: b.coolGray3,
  textColorSuccess: b.white,
  textColorInfo: b.white,
  textColorWarning: b.black,
  textColorError: b.black,
  textColorDisabled: b.white,
  borderWidth: h(1),
  borderStyle: "solid",
  borderColor: b.coolGray3,
  border: "".concat(h(1), " solid ").concat(b.coolGray3),
  borderColorDisabled: b.coolGray3,
  linkColor: b.black,
  linkColorHover: b.blue,
  linkColorActive: b.blue,
  linkDecoration: "underline",
  transitionDuration: "0.2s",
  hrPrimary: "".concat(h(4), " solid ").concat(b.charcoal),
  hrSecondary: "".concat(h(1), " solid ").concat(b.charcoal),
  hrTertiary: "".concat(h(1), " solid ").concat(b.coolGray3)
}),
    k = {
  typestack: "MVP"
},
    w = function w(e) {
  return k.typestack;
};

o.load({
  custom: {
    families: ["BrandFont-Text", "BrandFont-Display"],
    urls: ["https://respframework.verizon.com/fonts/v2/fonts.css"]
  }
});
var S = "BrandFont-Text",
    x = "BrandFont-Display",
    C = {
  VDS: {
    mobile: {
      extraExtraLarge: {
        fontSize: 32,
        lineHeight: 32,
        fontWeight: "bold",
        fontFamily: S
      },
      extraLarge: {
        fontSize: 32,
        lineHeight: 32,
        fontWeight: "bold",
        fontFamily: S
      },
      large: {
        fontSize: 24,
        lineHeight: 24,
        fontWeight: "bold",
        fontFamily: S
      },
      medium: {
        fontSize: 20,
        lineHeight: 20,
        fontWeight: "bold",
        fontFamily: S
      },
      small: {
        fontSize: 16,
        lineHeight: 16,
        fontWeight: "bold",
        fontFamily: S
      },
      extraSmall: {
        fontSize: 12,
        lineHeight: 11,
        fontWeight: "bold",
        fontFamily: S
      }
    },
    desktop: {
      extraExtraLarge: {
        fontSize: 64,
        lineHeight: 64,
        fontWeight: "bold",
        fontFamily: S
      },
      extraLarge: {
        fontSize: 48,
        lineHeight: 48,
        fontWeight: "bold",
        fontFamily: S
      },
      large: {
        fontSize: 32,
        lineHeight: 32,
        fontWeight: "bold",
        fontFamily: S
      },
      medium: {
        fontSize: 24,
        lineHeight: 24,
        fontWeight: "bold",
        fontFamily: S
      },
      small: {
        fontSize: 20,
        lineHeight: 20,
        fontWeight: "bold",
        fontFamily: S
      },
      extraSmall: {
        fontSize: 14,
        lineHeight: 14.5,
        fontWeight: "bold",
        fontFamily: S
      }
    }
  },
  MVP: {
    mobile: {
      extraExtraLarge: {
        fontSize: 34,
        lineHeight: 32.3,
        fontWeight: "750",
        fontFamily: x
      },
      extraLarge: {
        fontSize: 34,
        lineHeight: 32.3,
        fontWeight: "750",
        fontFamily: x
      },
      large: {
        fontSize: 25,
        lineHeight: 24,
        fontWeight: "750",
        fontFamily: x
      },
      medium: {
        fontSize: 16,
        lineHeight: 15,
        fontWeight: "750",
        fontFamily: x
      },
      small: {
        fontSize: 16,
        lineHeight: 15,
        fontWeight: "750",
        fontFamily: x
      },
      extraSmall: {
        fontSize: 12,
        lineHeight: 11,
        fontWeight: "750",
        fontFamily: x
      }
    },
    desktop: {
      extraExtraLarge: {
        fontSize: 64,
        lineHeight: 60.8,
        fontWeight: "750",
        fontFamily: x
      },
      extraLarge: {
        fontSize: 44,
        lineHeight: 41.8,
        fontWeight: "750",
        fontFamily: x
      },
      large: {
        fontSize: 32,
        lineHeight: 30.4,
        fontWeight: "750",
        fontFamily: x
      },
      medium: {
        fontSize: 24,
        lineHeight: 22.8,
        fontWeight: "750",
        fontFamily: x
      },
      small: {
        fontSize: 20,
        lineHeight: 19,
        fontWeight: "750",
        fontFamily: x
      },
      extraSmall: {
        fontSize: 14,
        lineHeight: 14.5,
        fontWeight: "750",
        fontFamily: x
      }
    }
  },
  getStyles: function getStyles(e, t, n) {
    return C[e][t][n];
  }
},
    O = ["#000000", "#FFFFFF", "#ffffff", "#F6F6F6", "#f6f6f6", "#D8DADA", "#d8dada", "#747676", "#333333", "#0088CE", "#0088ce"];
!function (e) {
  function t(t, n, o, r) {
    return r = r || "ANONYMOUS", null == n[o] ? t ? console.warn("Required ".concat(o, " was not specified in ").concat(r)) : null : e(n, o, r);
  }

  var n = t.bind(null, !1);
  n.isRequired = t.bind(null, !0);
}(function (e, t, n) {
  var o;
  return e && e[t] && !((o = e[t]) ? O.indexOf(o) > -1 : console.error("Need a color passed through")) ? console.warn("The color, ".concat(e[t], " is not a defined prop for ").concat(n, " ")) : null;
});

function z() {
  return (z = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];

      for (var o in n) {
        Object.prototype.hasOwnProperty.call(n, o) && (e[o] = n[o]);
      }
    }

    return e;
  }).apply(this, arguments);
}

function F(e, t) {
  if (null == e) return {};

  var n,
      o,
      r = function (e, t) {
    if (null == e) return {};
    var n,
        o,
        r = {},
        i = Object.keys(e);

    for (o = 0; o < i.length; o++) {
      n = i[o], t.indexOf(n) >= 0 || (r[n] = e[n]);
    }

    return r;
  }(e, t);

  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);

    for (o = 0; o < i.length; o++) {
      n = i[o], t.indexOf(n) >= 0 || Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
    }
  }

  return r;
}

var H = function H(e) {
  return {
    number: parseFloat(e),
    units: String(e).replace(/^[\d.-]+/, "")
  };
},
    P = function P() {
  for (var e = "", t = 0; t < arguments.length; ++t) {
    var n = t < 0 || arguments.length <= t ? void 0 : arguments[t];
    "" !== e && (e += " ");
    var o = H(n);
    "rem" !== o.units ? e += o.number / 16 : e += o.number, 0 != o.number && (e += "rem");
  }

  return e;
},
    j = {
  primitive: n.oneOf(["h1", "h2", "h3", "h4", "h5", "h6", "p", "a", "span"]),
  children: n.node
},
    G = t(function (t) {
  var n = t.primitive,
      o = t.children,
      r = F(t, ["primitive", "children"]);
  return e.createElement(n, r, o);
}).withConfig({
  displayName: "Typography__StyledTypography",
  componentId: "c213tb-0"
})(["font-size:", ";font-weight:", ";line-height:", ";font-family:", ";color:", ";margin:0;text-decoration:none;"], function (e) {
  var t = e.fontSize;
  return P(t);
}, function (e) {
  return e.fontWeight;
}, function (e) {
  var t = e.lineheight;
  return P(t);
}, function (e) {
  return e.fontFamily;
}, function (e) {
  return e.color;
}),
    W = function W(t) {
  var n = t.children,
      o = t.primitive,
      r = F(t, ["children", "primitive"]);
  return e.createElement(G, z({}, r, {
    primitive: o
  }), n);
};

W.propTypes = j, W.defaultProps = {
  children: null,
  primitive: "p"
};
n.oneOf(["h1", "h2", "h3", "h4", "h5", "h6", "a", "span", "p"]), n.oneOf(["desktop", "mobile", "tablet"]), n.oneOf(["extraSmall", "small", "medium", "large", "extraLarge", "extraExtraLarge"]), n.node, n.bool, n.oneOf(["VDS", "MVP"]), n.object, n.number, v.black, t(W).withConfig({
  displayName: "Title__StyledTitle",
  componentId: "sc-1j7ori5-0"
})(["&:active,&:hover{outline:none;}"]);
var E = {
  VDS: {
    mobile: {
      fontSize: 20,
      lineHeight: 24,
      fontWeight: "normal",
      fontFamily: S
    },
    desktop: {
      fontSize: 20,
      lineHeight: 24,
      fontWeight: "normal",
      fontFamily: S
    }
  },
  MVP: {
    mobile: {
      fontSize: 16,
      lineHeight: 19.2,
      fontWeight: "400",
      fontFamily: x
    },
    desktop: {
      fontSize: 20,
      lineHeight: 24,
      fontWeight: "400",
      fontFamily: x
    }
  },
  getStyles: function getStyles(e, t) {
    return E[e][t];
  }
},
    T = (n.oneOf(["h1", "h2", "h3", "h4", "h5", "h6", "a", "span", "p"]), n.oneOf(["desktop", "tablet", "mobile"]), n.node, n.oneOf(["VDS", "MVP"]), n.object, n.number, v.black, t(W).withConfig({
  displayName: "Subtitle__StyledSubtitle",
  componentId: "sc-98ihf2-0"
})(["&:active,&:hover{outline:none;}"]), {
  VDS: {
    mobile: {
      large: {
        fontSize: 16,
        lineHeight: 20,
        fontFamily: S
      },
      medium: {
        fontSize: 16,
        lineHeight: 20,
        fontFamily: S
      },
      small: {
        fontSize: 12,
        lineHeight: 16,
        fontFamily: S
      }
    },
    desktop: {
      large: {
        fontSize: 16,
        lineHeight: 20,
        fontFamily: S
      },
      medium: {
        fontSize: 16,
        lineHeight: 20,
        fontFamily: S
      },
      small: {
        fontSize: 12,
        lineHeight: 16,
        fontFamily: S
      }
    }
  },
  MVP: {
    mobile: {
      large: {
        fontSize: 12,
        lineHeight: 14.4,
        fontFamily: S
      },
      medium: {
        fontSize: 12,
        lineHeight: 14.4,
        fontFamily: S
      },
      small: {
        fontSize: 12,
        lineHeight: 14.4,
        fontFamily: S
      }
    },
    desktop: {
      large: {
        fontSize: 16,
        lineHeight: 19.2,
        fontFamily: S
      },
      medium: {
        fontSize: 14,
        lineHeight: 16.8,
        fontFamily: S
      },
      small: {
        fontSize: 12,
        lineHeight: 14.4,
        fontFamily: S
      }
    }
  },
  getStyles: function getStyles(e, t, n) {
    return T[e][t][n];
  }
});
n.oneOf(["h1", "h2", "h3", "h4", "h5", "h6", "a", "span", "p"]), n.oneOf(["desktop", "tablet", "mobile"]), n.oneOf(["small", "medium", "large"]), n.node, n.bool, n.oneOf(["VDS", "MVP"]), n.object, n.number, v.black, t(W).withConfig({
  displayName: "Body__StyledBody",
  componentId: "qpp2ii-0"
})(["&:active,&:hover{outline:none;}"]), n.oneOf(["h1", "h2", "h3", "h4", "h5", "h6", "a", "span", "p"]), n.oneOf(["desktop", "mobile", "tablet"]), n.node, n.oneOf(["VDS", "MVP"]), n.object, n.number, v.black, t(W).withConfig({
  displayName: "Micro__StyledMicro",
  componentId: "zo9y8f-0"
})(["&:active,&:hover{outline:none;}"]);

function I(e, t, n) {
  return t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}

function L(e, t) {
  var n = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    t && (o = o.filter(function (t) {
      return Object.getOwnPropertyDescriptor(e, t).enumerable;
    })), n.push.apply(n, o);
  }

  return n;
}

function B(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = null != arguments[t] ? arguments[t] : {};
    t % 2 ? L(n, !0).forEach(function (t) {
      I(e, t, n[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : L(n).forEach(function (t) {
      Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
    });
  }

  return e;
}

var D = function D(e) {
  return {
    number: parseFloat(e),
    units: String(e).replace(/^[\d.-]+/, "")
  };
},
    M = function M() {
  for (var e = "", t = 0; t < arguments.length; ++t) {
    var n = t < 0 || arguments.length <= t ? void 0 : arguments[t];
    "" !== e && (e += " ");
    var o = D(n);
    "rem" !== o.units ? e += o.number / 16 : e += o.number, 0 != o.number && (e += "rem");
  }

  return e;
},
    A = {
  black: "#000000",
  white: "#ffffff",
  red: "#d52b1e",
  charcoal: "#454545",
  green: "#00ac3e",
  blue: "#0088ce",
  yellow: "#ffbc3d",
  orange: "#ed7000",
  coolGray1: "#f6f6f6",
  coolGray3: "#d8dada",
  coolGray6: "#747676",
  coolGray10: "#333333",
  grayLight: "#d8dada"
},
    V = B({}, A, {}, {
  textColor: A.charcoal,
  textColorSuccess: A.white,
  textColorInfo: A.white,
  textColorWarning: A.charcoal,
  textColorError: A.white
}),
    _ = {
  fontFamily: '"BrandFont-Text", Helvetica, Arial, sans-serif',
  monospace: '"SFMono-Regular", "RobotoMono-Regular", monospace',
  sans: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"',
  serif: "serif",
  iconFontUrl: "https://respframework.verizon.com/fonts/verizon-icons/fonts.css",
  iconFont: "verizon-icons"
},
    Z = {
  light: 300,
  normal: 400,
  medium: 500,
  bold: 700
},
    N = B({}, _, {}, {
  fontColor: V.black,
  fontColorAlt: V.white,
  fontSize: M(16)
}, {
  fontWeights: Z,
  fontHeader: _.fontFamily,
  fontBody: _.sans,
  fontWeight: Z
}),
    R = B({
  name: "Verizon Theme"
}, V, {}, N, {}, {
  primary: V.black,
  secondary: V.white,
  accent: V.red,
  background: V.white,
  backgroundColorDisabled: V.coolGray3,
  success: V.green,
  info: V.blue,
  warning: V.yellow,
  error: V.orange,
  disabled: V.coolGray3,
  textColorSuccess: V.white,
  textColorInfo: V.white,
  textColorWarning: V.black,
  textColorError: V.black,
  textColorDisabled: V.white,
  borderWidth: M(1),
  borderStyle: "solid",
  borderColor: V.coolGray3,
  border: "".concat(M(1), " solid ").concat(V.coolGray3),
  borderColorDisabled: V.coolGray3,
  linkColor: V.black,
  linkColorHover: V.blue,
  linkColorActive: V.blue,
  linkDecoration: "underline",
  transitionDuration: "0.2s",
  hrPrimary: "".concat(M(4), " solid ").concat(V.charcoal),
  hrSecondary: "".concat(M(1), " solid ").concat(V.charcoal),
  hrTertiary: "".concat(M(1), " solid ").concat(V.coolGray3)
}),
    U = {
  "arrow-left": {
    viewBox: "0 0 24 24",
    path: ["M11.81,22,2.16,12.09,11.81,2,13,3.11,5.16,11.28H21.84v1.6H5.18l7.78,8Z"]
  },
  "arrow-right": {
    viewBox: "0 0 24 24",
    path: ["M12.19,22l9.65-9.91L12.19,2,11,3.11l7.81,8.17H2.16v1.6H18.82l-7.78,8Z"]
  },
  calendar: {
    viewBox: "0 0 24 24",
    path: ["M9.79,18.55a3.86,3.86,0,0,1-1.85-.45,3.72,3.72,0,0,1-1.78-3.38H7.59a2.45,2.45,0,0,0,1,2.13,2.82,2.82,0,0,0,2.67-.14,1.57,1.57,0,0,0,.78-1.45,1.55,1.55,0,0,0-.9-1.2,4.54,4.54,0,0,0-1.64-.28l-.65,0,0-1.42A5.68,5.68,0,0,0,10.82,12a1.23,1.23,0,0,0,.76-.93,1.48,1.48,0,0,0-1.22-1.39,2.09,2.09,0,0,0-2.53,1,2.36,2.36,0,0,0-.11.87H6.29a3.54,3.54,0,0,1,.21-1.4,3.51,3.51,0,0,1,4.24-1.83A2.84,2.84,0,0,1,13,11.14a2.43,2.43,0,0,1-1,1.76,2.83,2.83,0,0,1,1.48,2.26,3,3,0,0,1-1.44,2.75A4.19,4.19,0,0,1,9.79,18.55Zm8-10.09H16.32v0a1.8,1.8,0,0,1-.46,1.33,2,2,0,0,1-1.25.47h-.17v1.43h1.88v6.49h1.43ZM22,2H2V22H22ZM3.43,6.08H20.57V20.57H3.43Zm0-2.65H20.57V4.66H3.43Z"]
  },
  "caret-down": {
    viewBox: "0 0 24 24",
    path: ["M12,17.79,2,7.64,3.41,6.21,12,14.93l8.56-8.65L22,7.7Z"]
  },
  "caret-left-bold": {
    viewBox: "0 0 24 24",
    path: ["M15.85,22l-10-10L15.91,2l2.23,2.23L10.33,12l7.75,7.74Z"]
  },
  "caret-left": {
    viewBox: "0 0 24 24",
    path: ["M16.18,22l-10-10,10-10,1.55,1.54L9.3,12l8.43,8.43Z"]
  },
  "caret-right-bold": {
    viewBox: "0 0 24 24",
    path: ["M8.15,22l10-10L8.09,2,5.86,4.23,13.67,12,5.92,19.77Z"]
  },
  "caret-right": {
    viewBox: "0 0 24 24",
    path: ["M7.82,22,6.27,20.46,14.7,12,6.21,3.54,7.76,2l10,10Z"]
  },
  checkmark: {
    viewBox: "0 0 24 24",
    path: ["M8.94,19.23,2,12.29l1.41-1.4,5.53,5.53L20.59,4.77,22,6.18Z"]
  },
  close: {
    viewBox: "0 0 24 24",
    path: ["M13,12l9,9-1,1-9-9L3,22,2,21l9-9L2,3,3,2l9,9,9-9,1,1Z"]
  },
  collapse: {
    viewBox: "0 0 24 24",
    path: ["M22,13.5H2v-3H22Z"]
  },
  expand: {
    viewBox: "0 0 24 24",
    path: ["M22,13.43H13.43V22H10.57V13.43H2V10.57h8.57V2h2.86v8.57H22Z"]
  },
  "info-white": {
    viewBox: "0 0 24 24",
    path: ["M12,23C5.9,23,1,18.1,1,12C1,5.9,5.9,1,12,1c6.1,0,11,4.9,11,11C23,18.1,18.1,23,12,23z M12,2.6\n\t\t\tc-5.2,0-9.4,4.2-9.4,9.4c0,5.2,4.2,9.4,9.4,9.4c5.2,0,9.4-4.2,9.4-9.4C21.4,6.8,17.2,2.6,12,2.6z"],
    rect: [{
      x: "10.7",
      y: "10.8",
      class: "st0",
      width: "2.5",
      height: "8.2"
    }, {
      x: "10.7",
      y: "5.8",
      class: "st0",
      width: "2.5",
      height: "2.2"
    }]
  },
  info: {
    viewBox: "0 0 24 24",
    path: ["M12,22A10,10,0,1,1,22,12,10,10,0,0,1,12,22ZM12,3.43A8.57,8.57,0,1,0,20.57,12,8.59,8.59,0,0,0,12,3.43Zm1.2,7.4H10.8v7.89h2.4Zm0-4.78H10.8V8.16h2.4Z"]
  }
},
    q = function q(e) {
  return {
    number: parseFloat(e),
    units: String(e).replace(/^[\d.-]+/, "")
  };
},
    K = function K() {
  for (var e = "", t = 0; t < arguments.length; ++t) {
    var n = t < 0 || arguments.length <= t ? void 0 : arguments[t];
    "" !== e && (e += " ");
    var o = q(n);
    "rem" !== o.units ? e += o.number / 16 : e += o.number, 0 != o.number && (e += "rem");
  }

  return e;
};

function Y(e, t, n) {
  return t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}

function J(e, t) {
  var n = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    t && (o = o.filter(function (t) {
      return Object.getOwnPropertyDescriptor(e, t).enumerable;
    })), n.push.apply(n, o);
  }

  return n;
}

function Q(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = null != arguments[t] ? arguments[t] : {};
    t % 2 ? J(n, !0).forEach(function (t) {
      Y(e, t, n[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : J(n).forEach(function (t) {
      Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
    });
  }

  return e;
}

var X = function X(e) {
  return {
    number: parseFloat(e),
    units: String(e).replace(/^[\d.-]+/, "")
  };
},
    $ = function $() {
  for (var e = "", t = 0; t < arguments.length; ++t) {
    var n = t < 0 || arguments.length <= t ? void 0 : arguments[t];
    "" !== e && (e += " ");
    var o = X(n);
    "rem" !== o.units ? e += o.number / 16 : e += o.number, 0 != o.number && (e += "rem");
  }

  return e;
},
    ee = {
  black: "#000000",
  white: "#ffffff",
  red: "#d52b1e",
  charcoal: "#454545",
  green: "#00ac3e",
  blue: "#0088ce",
  yellow: "#ffbc3d",
  orange: "#ed7000",
  coolGray1: "#f6f6f6",
  coolGray3: "#d8dada",
  coolGray6: "#747676",
  coolGray10: "#333333",
  grayLight: "#d8dada"
},
    te = Q({}, ee, {}, {
  textColor: ee.charcoal,
  textColorSuccess: ee.white,
  textColorInfo: ee.white,
  textColorWarning: ee.charcoal,
  textColorError: ee.white
}),
    ne = {
  fontFamily: '"BrandFont-Text", Helvetica, Arial, sans-serif',
  monospace: '"SFMono-Regular", "RobotoMono-Regular", monospace',
  sans: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"',
  serif: "serif",
  iconFontUrl: "https://respframework.verizon.com/fonts/verizon-icons/fonts.css",
  iconFont: "verizon-icons"
},
    oe = {
  light: 300,
  normal: 400,
  medium: 500,
  bold: 700
},
    re = Q({}, ne, {}, {
  fontColor: te.black,
  fontColorAlt: te.white,
  fontSize: $(16)
}, {
  fontWeights: oe,
  fontHeader: ne.fontFamily,
  fontBody: ne.sans,
  fontWeight: oe
}),
    ie = Q({
  name: "Verizon Theme"
}, te, {}, re, {}, {
  primary: te.black,
  secondary: te.white,
  accent: te.red,
  background: te.white,
  backgroundColorDisabled: te.coolGray3,
  success: te.green,
  info: te.blue,
  warning: te.yellow,
  error: te.orange,
  disabled: te.coolGray3,
  textColorSuccess: te.white,
  textColorInfo: te.white,
  textColorWarning: te.black,
  textColorError: te.black,
  textColorDisabled: te.white,
  borderWidth: $(1),
  borderStyle: "solid",
  borderColor: te.coolGray3,
  border: "".concat($(1), " solid ").concat(te.coolGray3),
  borderColorDisabled: te.coolGray3,
  linkColor: te.black,
  linkColorHover: te.blue,
  linkColorActive: te.blue,
  linkDecoration: "underline",
  transitionDuration: "0.2s",
  hrPrimary: "".concat($(4), " solid ").concat(te.charcoal),
  hrSecondary: "".concat($(1), " solid ").concat(te.charcoal),
  hrTertiary: "".concat($(1), " solid ").concat(te.coolGray3)
}),
    ae = t.svg.withConfig({
  displayName: "Icon__StyledSVG",
  componentId: "y10cf0-0"
})(["background-color:", ";display:inline-block;", ";"], function (e) {
  return e.backgroundColor;
}, function (e) {
  return e.tabIndex < 0 && "\n    outline: none;\n    pointer-events: none;\n  ";
}),
    le = function le(e) {
  if ("number" == typeof e) return K(e);

  switch (e) {
    case "extraLarge":
      return K(28);

    case "large":
      return K(24);

    case "medium":
      return K(20);

    case "small":
      return K(16);

    case "extraSmall":
    default:
      return K(12);
  }
},
    ce = function ce(t) {
  t.ariaHidden;
  var n = t.name,
      o = t.size,
      r = t.lineColor,
      i = t.color,
      a = t.backgroundColor,
      l = t.inverted,
      c = U[n],
      d = r || i;
  return (!l || i || r) && (!l || "black" !== i && i !== ie.black && "Black" !== i) || (d = ie.white), c ? e.createElement(ae, {
    "aria-label": t.ariaLabel ? t.ariaLabel : n + " icon",
    tabIndex: t.tabIndex,
    width: le(o),
    height: le(o),
    viewBox: c.viewBox,
    backgroundColor: a || "transparent",
    style: t.style
  }, e.createElement("g", null, c.path.map(function (t) {
    return e.createElement("path", {
      key: t,
      fill: d,
      d: t
    });
  }), c.polygon && c.polygon.map(function (t) {
    return e.createElement("polygon", {
      key: t,
      fill: d,
      points: t
    });
  }), c.circle && c.circle.map(function (t) {
    return e.createElement("circle", {
      key: "".concat(t.cx).concat(t.cy).concat(t.r),
      fill: d,
      cx: t.cx,
      cy: t.cy,
      r: t.r
    });
  }), c.rect && c.rect.map(function (t) {
    return e.createElement("rect", {
      key: "".concat(t.x).concat(t.y),
      fill: d,
      x: t.x,
      y: t.y,
      transform: t.transform,
      width: t.width,
      height: t.height
    });
  }), c.pathOther && c.pathOther.map(function (t) {
    return e.createElement("path", {
      key: t.d,
      d: t.d,
      fill: d,
      transform: t.transform
    });
  }))) : null;
},
    de = {
  ariaLabel: n.string,
  name: n.string.isRequired,
  size: n.oneOfType([n.number, n.string]),
  lineColor: n.string,
  color: n.string,
  backgroundColor: n.string,
  style: n.object,
  tabIndex: n.number,
  inverted: n.bool
};

ce.propTypes = de, ce.defaultProps = {
  size: "extraSmall",
  color: "black",
  backgroundColor: "transparent",
  style: void 0,
  lineColor: void 0,
  tabIndex: 0,
  inverted: !1
};
var fe = {
  iconPosition: n.oneOf(["left", "right"]),
  onClick: n.func,
  href: n.string,
  disabled: n.bool,
  inverted: n.bool,
  children: n.oneOfType([n.node, n.string]),
  theme: n.object,
  ariaLabel: n.string
},
    se = {
  iconPosition: "right",
  disabled: !1,
  inverted: !1,
  theme: R
},
    ue = w(),
    he = C.getStyles(ue, "desktop", "extraSmall"),
    me = t.a.withConfig({
  displayName: "TextLinkCaret__StyledAnchor",
  componentId: "ksbeve-0"
})(["width:auto;display:flex;align-items:center;padding:0;margin:0 0 0 1rem;border:0;cursor:pointer;background-image:none;background-color:transparent;text-decoration:none;font-size:", ";font-family:", ";font-weight:", ";line-height:", ";font-style:normal;color:", ";transition:opacity 0.15s ease-in;touch-action:manipulation;background-color:transparent;align-content:center;width:fit-content;*{mouse-events:none;outline:none;}&:active{opacity:0.77;transition:opacity 0.15s ease-out;}", " ", " ", ";.CTA-Text{position:relative;display:inline-block;}&:hover .CTA-Text,&:focus .CTA-Text{::after{content:'';position:absolute;bottom:", ";left:0;right:0;width:100%;border-bottom:", " solid ", ";}}"], c(he.fontSize), he.fontFamily, he.fontWeight, c(he.lineHeight), function (e) {
  return e.theme.primary;
}, function (e) {
  var t = e.inverted,
      n = e.theme;
  return t && "\n    color: ".concat(n.secondary, ";\n    &:active {\n      opacity: 0.77;\n      transition: opacity .15s ease-out;\n    }\n  ");
}, function (e) {
  var t = e.disabled,
      n = e.theme;
  return t && "\n    pointer-events: none;\n    cursor: not-allowed;\n    color: ".concat(n.coolGray3, ";\n    &:hover {\n      background-color: transparent;\n    }\n  ");
}, function (e) {
  var t = e.disabled,
      n = e.inverted,
      o = e.theme;
  return t && n && "\n    color: ".concat(o.coolGray10, ";\n  ");
}, c(-4), c(1), function (e) {
  var t = e.theme;
  return e.inverted ? t.white : t.black;
}),
    be = t.span.withConfig({
  displayName: "TextLinkCaret__AnchorContentWrapper",
  componentId: "ksbeve-1"
})(["display:flex;align-items:center;"]),
    pe = t.span.withConfig({
  displayName: "TextLinkCaret__StyledSpan",
  componentId: "ksbeve-2"
})(["padding-left:", ";padding-right:", ";"], function (e) {
  return "left" === e.iconPosition ? c(4) : 0;
}, function (e) {
  return "right" === e.iconPosition ? c(4) : 0;
});

function ye(e, t) {
  return t && e ? R.coolGray10 : t && !e ? R.white : !t && e ? R.coolGray3 : R.black;
}

var ge = function ge(t) {
  function n(e) {
    t.onClick(e), e.click && e.currentTarget.blur();
  }

  return e.createElement(me, r({}, t, {
    onKeyPress: function onKeyPress(e) {
      console.log(e.key), "Enter" !== e.key && " " !== e.key && "Spacebar" !== e.key || (e.preventDefault(), n(e), href && window.location.assign(href));
    },
    onClick: n,
    href: t.href,
    disabled: t.disabled,
    inverted: t.inverted,
    theme: t.theme,
    role: "link",
    "aria-disabled": t.disabled,
    tabIndex: 0,
    ariaLabel: t.ariaLabel ? t.ariaLabel : "string" == typeof t.children ? t.children : "Text Link Caret"
  }), e.createElement(be, {
    ariaHidden: !0,
    tabIndex: -1
  }, "left" === t.iconPosition && e.createElement(ce, {
    tabIndex: -1,
    name: "caret-left",
    size: "small",
    color: ye(t.disabled, t.inverted)
  }), e.createElement(pe, {
    ariaHidden: !0,
    tabIndex: -1,
    iconPosition: t.iconPosition,
    className: "TextLinkCaret-Text"
  }, t.children), "right" === t.iconPosition && e.createElement(ce, {
    tabIndex: -1,
    name: "caret-right",
    size: "small",
    color: ye(t.disabled, t.inverted)
  })));
};

ge.defaultProps = se, ge.propTypes = fe;

var ve = {
  type: n.oneOf(["inline", "standAlone"]),
  viewport: n.oneOf(["mobile", "tablet", "desktop"]),
  children: n.oneOfType([n.node, n.string]),
  disabled: n.bool,
  inverted: n.bool,
  onClick: n.func,
  href: n.string,
  theme: n.object,
  color: n.oneOf([R.blue, R.black]),
  bold: n.bool,
  ariaLabel: n.string
},
    ke = {
  viewport: "desktop",
  type: "inline",
  disabled: !1,
  inverted: !1,
  onClick: function onClick() {},
  theme: R,
  bold: !1,
  color: R.primary
},
    we = w(),
    Se = T.getStyles(we, "desktop", "medium"),
    xe = T.getStyles(we, "mobile", "medium"),
    Ce = t.a.withConfig({
  displayName: "TextLink__StyledAnchor",
  componentId: "sc-1s71xtd-0"
})(["width:auto;display:inline-block;position:relative;vertical-align:middle;padding:", ";border:0;cursor:pointer;background-image:none;background-color:transparent;text-decoration:none;font-size:", ";font-family:", ";font-weight:", ";line-height:", ";color:", ";border-bottom:", " solid;border-color:", ";transition:opacity 0.15s ease-in;touch-action:manipulation;&:hover,&:active,&:visited{outline:none;}&:active{opacity:0.77;transition:opacity 0.15s ease-out;}&:hover{color:", ";border-bottom:", " solid ", ";}", " ", " ", " ", ";"], c(0, 0, 1, 0), function (e) {
  return "inline" === e.type ? "inherit" : c(Se.fontSize);
}, function (e) {
  return "inline" === e.type ? "inherit" : Se.fontFamily;
}, function (e) {
  var t = e.type;
  return e.bold ? "750" : "inline" === t ? "inherit" : Se.fontWeight;
}, function (e) {
  return "inline" === e.type ? "inherit" : c(Se.lineHeight);
}, function (e) {
  return e.color;
}, c(1), function (e) {
  return e.color;
}, function (e) {
  return e.theme.blue;
}, c(1), R.blue, function (e) {
  var t = e.viewport,
      n = e.type;
  return "mobile" === t && "inline" !== n && "\n      font-size: ".concat(c(xe.fontSize), ";\n      font-family: ").concat(xe.fontFamily, ";\n      font-weight: ").concat(xe.fontWeight, ";\n      line-height: ").concat(c(xe.lineHeight), ";\n    ");
}, function (e) {
  var t = e.inverted,
      n = e.color,
      o = e.theme;
  return t && "\n    color: ".concat(n && n !== R.black ? n : o.white, ";\n    border-bottom: ").concat(c(1), " solid ").concat(n && n !== R.black ? n : o.white, ";\n    &:active {\n      opacity: 0.77;\n      transition: opacity .15s ease-out;\n    }\n  ");
}, function (e) {
  var t = e.disabled,
      n = e.theme;
  return t && "\n    pointer-events: none;\n    cursor: not-allowed;\n    color: ".concat(n.coolGray3, ";\n    border-bottom: ").concat(c(1), " solid ").concat(n.coolGray3, ";\n    &:hover {\n      background-color: transparent;\n      color: ").concat(n.coolGray3, ";\n      border-bottom: ").concat(c(1), " solid ").concat(n.coolGray3, ";\n    }\n  ");
}, function (e) {
  var t = e.disabled,
      n = e.inverted,
      o = e.theme;
  return t && n && "\n    border-bottom: ".concat(c(1), " solid ").concat(o.coolGray10, ";\n    color: ").concat(o.coolGray10, ";\n    \n  ");
}),
    Oe = function Oe(t) {
  var n = t.type,
      o = t.viewport,
      a = t.children,
      l = t.disabled,
      c = t.inverted,
      d = t.onClick,
      f = t.href,
      s = t.theme,
      u = t.color,
      h = t.bold,
      m = t.ariaLabel,
      b = i(t, ["type", "viewport", "children", "disabled", "inverted", "onClick", "href", "theme", "color", "bold", "ariaLabel"]),
      p = m || ("string" == typeof a ? a : "Text Link");
  return e.createElement(Ce, r({}, b, {
    onKeyPress: function onKeyPress(e) {
      "Enter" !== e.key && " " !== e.key && "Spacebar" !== e.key || (e.preventDefault(), d && d(), f && window.location.assign(f));
    },
    type: n,
    viewport: o,
    disabled: l,
    inverted: c,
    onClick: function onClick(e) {
      d(e), "click" === e.type && e.target.blur();
    },
    href: f,
    theme: s,
    color: u,
    bold: h,
    "aria-label": p,
    role: "link",
    "aria-disabled": b.disabled,
    tabIndex: 0
  }), a);
};

Oe.defaultProps = ke, Oe.propTypes = ve;

var ze = {
  children: n.oneOfType([n.node, n.string]),
  disabled: n.bool,
  onClick: n.func,
  size: n.oneOf(["normal", "tiny", "small", "large", "block"]),
  width: n.oneOfType([n.number, n.string]),
  theme: n.object,
  display: n.oneOf(["flex", "inline-block", "block"]),
  ariaLabel: n.string
},
    Fe = {
  children: null,
  disabled: !1,
  size: "large",
  display: "flex",
  onClick: function onClick() {},
  theme: R
},
    He = w(),
    Pe = C.getStyles(He, "desktop", "extraSmall"),
    je = C.getStyles(He, "mobile", "extraSmall"),
    Ge = (E.getStyles(He, "desktop"), t.span.withConfig({
  displayName: "ButtonBase__StyledChildWrapper",
  componentId: "sc-1rk6qm3-0"
})(["border:none;overflow:hidden;display:", ";align-items:center;justify-content:", ";", "};"], function (e) {
  return "flex" === e.display ? "flex" : "block";
}, function (e) {
  return e.width ? "flex-start" : "center";
}, function (e) {
  var t = e.size,
      n = e.width,
      o = c(n ? 21 : 42);
  if ("block" === t) return "margin: auto";

  switch (t) {
    case "tiny":
      return "\n          margin: ".concat(c(0, 13), ";\n        ");

    case "small":
      return "\n          margin-right: ".concat(c(n ? 12 : 24), ";\n          margin-left: ").concat(c(n ? 12 : 24), ";\n          padding: ").concat(c(6.5, 0), ";\n        ");

    case "block":
      return "\n          display: block;\n          width: 100%;\n          margin-right: ".concat(o, ";\n          margin-left: ").concat(o, ";\n        ");

    default:
      return "\n          margin-right: ".concat(o, ";\n          margin-left: ").concat(o, ";\n        ");
  }
})),
    We = function We(e) {
  return "string" == typeof e ? e : c(e);
},
    Ee = t.button.withConfig({
  displayName: "ButtonBase__StyledButtonBase",
  componentId: "sc-1rk6qm3-1"
})(["padding:0;border-radius:", ";border-width:", ";box-sizing:border-box;cursor:pointer;display:", ";flex-direction:row;align-items:center;justify-content:center;font-family:", ";font-size:", ";font-weight:", ";line-height:", ";height:", ";position:relative;text-align:center;text-decoration:none;touch-action:manipulation;transition-duration:0.15s;transition-property:color;vertical-align:middle;width:auto;overflow:hidden;&:active,&:visited{outline:none;}&:hover,&:active,&.is-active,&.link.active,&.link.hover,&.link:active,&.link:hover{text-decoration:none;}", "};"], c(100), c(1), function (e) {
  return e.display;
}, Pe.fontFamily, c(Pe.fontSize), 750, c(Pe.lineHeight), c(42), function (e) {
  var t = e.size,
      n = e.width;
  return "tiny" === t ? "\n        font-size: ".concat(c(je.fontSize), ";\n        line-height: ").concat(c(je.lineHeight), ";\n        font-family: ").concat(je.fontFamily, ";\n      ") : "small" === t ? "\n        font-size: ".concat(c(je.fontSize), ";\n        line-height: ").concat(c(je.lineHeight), ";\n        font-family: ").concat(je.fontFamily, ";\n        height: ").concat(c(24), "; \n        width: ").concat(n ? We(n) : "auto", ";\n        white-space: nowrap;\n      ") : "large" === t ? "\n        width: ".concat(n ? We(n) : "auto", ";\n        height: ").concat(c(42), ";\n        white-space: nowrap;\n      ") : "block" === t ? "\n        display: block;\n        width: 100%;\n      " : void 0;
}),
    Te = function Te(t) {
  var n = t.children,
      o = t.size,
      a = t.width,
      l = t.ariaLabel,
      c = t.onClick,
      d = t.display,
      f = i(t, ["children", "size", "width", "ariaLabel", "onClick", "display"]),
      s = l || ("string" == typeof n ? n : "Button");
  return e.createElement(Ee, r({
    size: o,
    width: a,
    "aria-label": s,
    role: "button",
    "aria-disabled": f.disabled,
    tabIndex: 0,
    onClick: function onClick(e) {
      0 !== e.detail ? (c(e), e.target.blur()) : "click" === e.type && c(e);
    },
    display: d
  }, f), e.createElement(Ge, {
    display: d,
    size: o,
    width: a
  }, n));
};

Te.defaultProps = Fe, Te.propTypes = ze;
var Ie = {
  children: n.node,
  disabled: n.bool,
  inverted: n.bool,
  onClick: n.func,
  width: n.oneOfType([n.string, n.number]),
  size: n.oneOf(["normal", "tiny", "small", "large", "block"]),
  theme: n.object,
  ariaLabel: n.string
},
    Le = {
  children: null,
  disabled: !1,
  inverted: !1,
  onClick: function onClick() {},
  size: "large",
  theme: R
},
    Be = t(Te).withConfig({
  displayName: "ButtonPrimary",
  componentId: "j6uf9b-0"
})(["background-color:", ";border:", ";color:", ";", ";", ";", ";"], function (e) {
  return e.theme.primary;
}, function (e) {
  var t = e.theme;
  return "".concat(c(1), " solid ").concat(t.primary);
}, function (e) {
  return e.theme.secondary;
}, function (e) {
  var t = e.inverted,
      n = e.theme;
  return t && "\n    background-color: ".concat(n.secondary, ";\n    border-color: ").concat(n.secondary, ";\n    color: ").concat(n.primary, ";\n  ");
}, function (e) {
  var t = e.disabled,
      n = e.theme;
  return t && "\n    background-color: ".concat(n.coolGray3, ";\n    border-color: ").concat(n.coolGray3, ";\n    cursor: default;\n  ");
}, function (e) {
  var t = e.disabled,
      n = e.inverted,
      o = e.theme;
  return t && n && "\n    background-color: ".concat(o.coolGray10, ";\n    border-color: ").concat(o.coolGray10, ";\n    color: ").concat(o.primary, "\n  ");
});
Be.defaultProps = Le, Be.propTypes = Ie;
var De = {
  children: n.node,
  disabled: n.bool,
  inverted: n.bool,
  onClick: n.func.isRequired,
  size: n.oneOf(["normal", "tiny", "small", "large", "block"]),
  width: n.oneOfType([n.string, n.number]),
  theme: n.object
},
    Me = {
  children: null,
  disabled: !1,
  inverted: !1,
  size: "large",
  onClick: function onClick() {},
  theme: R
},
    Ae = t(Te).withConfig({
  displayName: "ButtonSecondary",
  componentId: "fwrhf5-0"
})(["background-color:transparent;border:", ";color:", ";&:hover,&:active,&.is-active,&.link.active,&.link.hover,&.link:active,&.link:hover{text-decoration:none;}", ";", ";", ";"], function (e) {
  var t = e.theme;
  return "".concat(c(1), " solid ").concat(t.black);
}, function (e) {
  return e.theme.black;
}, function (e) {
  var t = e.inverted,
      n = e.theme;
  return t && "\n    border-color: ".concat(n.secondary, ";\n    color: ").concat(n.secondary, ";\n  ");
}, function (e) {
  var t = e.disabled,
      n = e.theme;
  return t && "\n    background-color: transparent;\n    border-color: ".concat(n.coolGray3, ";\n    color: ").concat(n.coolGray3, ";\n    cursor: default;\n  ");
}, function (e) {
  var t = e.disabled,
      n = e.inverted,
      o = e.theme;
  return t && n && "\n    border-color: ".concat(o.coolGray10, ";\n    color: ").concat(o.coolGray10, ";\n  ");
});
Ae.defaultProps = Me, Ae.propTypes = De;

var Ve = {
  type: n.string,
  children: n.node
},
    _e = function _e(t) {
  var n = t.type,
      o = t.children,
      r = i(t, ["type", "children"]);

  switch (n) {
    case "secondary":
      return e.createElement(Ae, r, o);

    case "primary":
    default:
      return e.createElement(Be, r, o);
  }
};

_e.propTypes = Ve, _e.defaultProps = {
  type: "primary"
};
export { _e as Button, Oe as TextLink, ge as TextLinkCaret };